import request from "@/utils/request";

export function getDarList(data) {
  return request({
    url:'/job/dar/getDarList',
    method: 'post',
    data
  })
}

export function getDarExam(data) {
  return request({
    url:'/job/dar/getDarExam',
    method: 'post',
    data
  })
}


export function calResult(data){
  return request({
    url:'/job/dar/calResult',
    method:'post',
    data
  })
}


export function getResult(id){
  return request({
    url:'/job/dar/getResult?id=' + id,
    method:'get'
  })
}

export function checkResult(id){
  let data = {
    examId:id
  }
  return request({
    url:'/job/dar/checkResult',
    method:'post',
    data
  })
}


export function inviteExam(data) {
  return request({
    url:'/job/dar/inviteExam',
    method:'post',
    data
  })
}

export function searchInviteExam(data) {
  return request({
    url:'/job/dar/searchInviteExam',
    method:'post',
    data
  })
}

export function searchMyInvite(data) {
  return request({
    url:'/job/dar/searchMyInvite',
    method:'post',
    data,
    headers: {
      "hideLoading": true
    }
  })
}

export function searchMyAdvice(data) {
  return request({
    url:'/job/dar/searchMyAdvice',
    method:'post',
    data
  })
}

export  function getExamStatistics(){
  return request({
    url:'/job/dar/getExamStatistics',
    method:'post',
    headers: {
      "hideLoading": true
    }
  })
}

export function updateEnsureState(id) {
  return request({
    url:'/job/dar/updateEnsureState?id=' + id,
    method:'get'
  })
}

export function inviteExamBatch(data){
  return request({
    url:'/job/dar/inviteExamBatch',
    method:'post',
    data
  })
}

export function noticeUserTest(id) {
  return request({
    url:'/job/dar/noticeUserTest',
    method:'get',
    params:{
      id:id
    }
  })
}

export function getSubjectList(data) {
  return request({
    url: '/job/dar/getSubjectList',
    method: 'post',
    data
  })
}

export function updateSubjectVisibleType(data) {
  return request({
    url: '/job/dar/updateSubjectVisibleType',
    method: 'post',
    data
  })
}

export function adviceExam(data) {
  return request({
    url: '/job/dar/adviceExam',
    method: 'post',
    data,
    headers: {
      "hideLoading": true
    }
  })
}

export function getInviteInfo(inviteId) {
  return request({
    url: '/job/dar/getInviteInfo?inviteId=' + inviteId,
    method: 'post',
    headers: {
      "hideLoading": true
    }
  })
}

export function checkInviteState(inviteId) {
  return request({
    url: '/job/dar/checkInviteState?inviteId=' + inviteId,
    method: 'post',
    headers: {
      "hideLoading": true
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/exam.js